import { forwardRef, useContext } from 'react';
import { ToggleButton, type ToggleButtonProps } from '../Form';
import { TooltipBubble } from '../TooltipBubble';
import { NavbarContext } from './NavbarContext';

export interface NavbarToggleButtonProps
  extends Pick<
    ToggleButtonProps,
    | 'disabled'
    | 'label'
    | 'icon'
    | 'leftIcon'
    | 'onSelect'
    | 'rightIcon'
    | 'selected'
  > {
  tooltipMessage?: string;
}

export const NavbarToggleButton = forwardRef<
  HTMLDivElement,
  NavbarToggleButtonProps
>(
  (
    {
      disabled,
      label,
      icon,
      leftIcon,
      onSelect,
      rightIcon,
      selected,
      tooltipMessage,
    },
    ref
  ) => {
    const { theme: navbarTheme = 'light' } = useContext(NavbarContext);

    return (
      <TooltipBubble
        placement="top"
        title={tooltipMessage}
        disabled={!tooltipMessage}
      >
        <ToggleButton
          ref={ref}
          disabled={disabled}
          label={label}
          icon={icon}
          leftIcon={leftIcon}
          rightIcon={rightIcon}
          onSelect={onSelect}
          selected={selected}
          dark={navbarTheme === 'dark'}
        />
      </TooltipBubble>
    );
  }
);
